import React, { useEffect, useState, useContext } from 'react';
import { useOktaAuth } from '@okta/okta-react';
import SearchService from '../../../services/SearchService';
import { stateDefinition } from '../../../types/definitions/State';
import LoadingContext from './loading-context';
import SearchDataContext from '../../../providers/searchData-context';
import { Form } from 'react-bootstrap';

const StatePicker: React.FC = () => {
    const { oktaAuth, authState } = useOktaAuth();
    const [stateList, setStateList] = useState<stateDefinition[]>();
    const loadingCtx = useContext(LoadingContext);
    const searchDataCtx = useContext(SearchDataContext);

    const uid: string = authState.accessToken.claims?.uid;
    //const userName: string = authState.accessToken.claims?.sub;
    const accessToken: string = authState.accessToken.accessToken;

    useEffect(() => {
        if (!authState) return;

        loadingCtx.setIsLoading(true, 'StatePicker');

        SearchService.getStates(accessToken, uid)
            .then((response) => {
                setStateList(response as stateDefinition[]);
                loadingCtx.setIsLoading(false, 'StatePicker');
            })
            .catch((ex) => {
                //setError(ex.response);
                //setIsError(true);
                loadingCtx.setIsLoading(false, 'StatePicker');
            });
    }, []);

    if (!authState) {
        return <div></div>;
    }

    const onChange = (e: any) => {
        searchDataCtx.setState(e.target.value);
    };

    const sortedStates = stateList?.sort((a, b) => {
        const nameA = a.name.toUpperCase();
        const nameB = b.name.toUpperCase();
        if (nameA < nameB) {
            return -1;
        }
        if (nameA > nameB) {
            return 1;
        }
        return 0;
    });

    return (
        <>
            <label>State</label>
            <div className='col'>
                <Form.Control
                    tabIndex={1}
                    id='search-state'
                    className='form-select form-select-sm'
                    as='select'
                    required
                    onChange={onChange}
                    value={searchDataCtx.state}
                    name='state'
                >
                    <option value=''>Choose...</option>
                    {sortedStates &&
                        sortedStates.map((data: stateDefinition) => (
                            <option key={data.code} value={data.code}>
                                {data.name}
                            </option>
                        ))}
                </Form.Control>
                <Form.Control.Feedback type='invalid'>
                    Please choose your State
                </Form.Control.Feedback>
            </div>
        </>
    );
};

export default StatePicker;
